import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home';
import Editorial from '../views/Editorial.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Signe Larsen' }
  },
  {
    path: '/social',
    name: 'Editorial',
    component: Editorial,
    meta: { title: 'Signe Larsen - News & Social Media' }
  },
  {
    path: '/branded',
    name: 'Branded',
    component: () => import('../views/Branded.vue'),
    meta: { title: 'Signe Larsen - Branded' }
  },
  // {
  //   path: '/images',
  //   name: 'Images',
  //   component: () => import('../views/Images.vue'),
  //   meta: { title: 'Signe Larsen - Images' }
  // },
  // {
  //   path: '/stories',
  //   name: 'Stories',
  //   component: () => import('../views/Stories.vue'),
  //   meta: { title: 'Signe Larsen - Stories' }
  // },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { title: 'Signe Larsen - About' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: { title: 'Signe Larsen - Contact' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
